import React from 'react';

const allPrivileges = Object.values(
  GLOBALS.PRIVILEGES.reduce((acc, p) => {
    acc[p.resource] = !acc[p.resource] || p.title ? p : acc[p.resource];
    return acc;
  }, {})
);

export default [
  {
    title: 'Privilege Name',
    dataIndex: 'resource',
    sorter: true,
    render: (_, { resource }) => {
      return <span>{allPrivileges.find(p => p.resource === resource)?.title || ''}</span>;
    }
  },
  {
    title: 'Description',
    dataIndex: 'description',
    render: (_, { resource, description }) => (
      <div style={{ maxWidth: 400, whiteSpace: 'break-spaces' }}>
        {allPrivileges.find(p => p.resource === resource)?.description || ''}
      </div>
    )
  },
  {
    title: 'Groups',
    dataIndex: 'groups',
    render: (_, { groups }) => (
      <div className="defect-scroll">{(groups || []).join(', ') || 'No groups assigned'}</div>
    )
  }
];
